/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Actor_YouInputs */

const en_live_actor_you = /** @type {(inputs: Live_Actor_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you`)
};

const de_live_actor_you = /** @type {(inputs: Live_Actor_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dir`)
};

/**
* | output |
* | --- |
* | "you" |
*
* @param {Live_Actor_YouInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const live_actor_you = /** @type {((inputs?: Live_Actor_YouInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Actor_YouInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_live_actor_you(inputs)
	return en_live_actor_you(inputs)
});